import { LOCALE_CODE } from 'app/constants/language';

export const LOCAL_STORAGE_KEY = 'browseHomePageIndex';

export const MOCK_BROWSE_HOME_PAGE_INDEX = {
  '1234': {
    browseHomePageId: '1234',
    createdBy: 'timletofskokiestage',
    localeCode: LOCALE_CODE.UNITED_STATES_ENGLISH,
    name: 'First Browse Home Page',
    updatedAt: Date.now(),
    updatedBy: 'timletofskokiestage'
  },
  '2468': {
    browseHomePageId: '2468',
    createdBy: 'timletofskokiestage',
    localeCode: LOCALE_CODE.UNITED_STATES_ENGLISH,
    name: 'Second Browse Home Page',
    updatedAt: Date.now(),
    updatedBy: 'timletofskokiestage'
  }
};
